// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  Row,
  Col,
  Checkbox,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Alert
}                     from 'react-bootstrap';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import { createBrowserHistory } from 'history';
import { withRouter, Link } from 'react-router-dom';

import isEmpty from 'lodash.isempty';
import Pagination from 'react-paginating';

import '../dashboard/dashboard.scss';
import CountryStateCity from '../../../components/countryStateCity/CountryStateCity';
import { getAllCategory } from "../../../redux/actions/dealActions";
import { becomePartner } from '../../../redux/actions/frontActions';
import logo from '../../../img/ddb-logo.png';

import { Notification } from '../../../components/notifications';
import { getContractPoposal } from "../../../redux/actions/contractActions";
import { executeContract} from '../../../redux/actions/pageTemplateAction';
import {renderAlert,clearAlert} from '../../../redux/actions/alertsActions';
import NumberFormat from "react-number-format";
import Cookies from 'universal-cookie';
const cookies = new Cookies();
import ReactHtmlParser from "react-html-parser";

const history = createBrowserHistory();
class Proposal extends Component {
  constructor(props, context){
    super(props, context);
    this.state = {
      userName: '',
      businessName: '',
      websiteUrl: '',
      catList: '',
      hearAbout:'',
      contactName:'',
      email:'',
      phone:'',
      catID:'',
      country:'',
      state:'',
      city:'',
      cityID:'',
      onlineRetailor:'no',
      showAlert: false,
      disabled:'',
      executed: 'yes',
      contractData: '',
      termsAgree: 'termsAgree',
    };

    this.handleChange = this.handleChange.bind(this);

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.Clear=this.Clear.bind(this);
  }

  handleChange = (e) => {
    this.setState({[e.target.name] : e.target.value});

    if(`${e.target.name}Error` !== ''){
      this.setState({[`${e.target.name}Error`]:''})
    }
    this.setState({ disabled: false });
  }

  handleClick = (event) => {
    if (event.target.id =="agreeTermCondition1" && event.target.checked) {
      document.getElementById("agreeTermCondition").remove();
      document.getElementById("addAgree").innerHTML = '<input id="agreeTermCondition" type="checkbox" name="termCondition"/>';
      this.setState({ termsAgree: 'termsAgree1' });
    }else if (event.target.id =="agreeTermCondition" && event.target.checked){
      document.getElementById("agreeTermCondition1").checked = false;
      document.getElementById("agreeTermCondition1").removeAttribute("checked")
      document.getElementById("agreeTermCondition1").removeAttribute("required")
      this.setState({ termsAgree: 'termsAgree' });
    }
  }

  handleDismiss() {
    this.setState({ showAlert: false });
  }

  handleShow() {
    this.setState({ showAlert: true });
  }

  Clear(){
    this.setState({
      name: '',
      title: '',
      email: '',
      disabled: false,
    });
  }

  handlePageChange = page => {
    let contractIdParams = this.props.route.match.params.contractID
      ? this.props.route.match.params.contractID
      : "";
    if (contractIdParams !== "") {
      this.props.getContractPoposal(contractIdParams);
    }
  };

  componentWillMount() {
    if(this.props.themeData){
      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }
    this.handlePageChange(1);
  }

  componentWillReceiveProps(nextProps){
      if(nextProps.themeData){
        if(nextProps.themeData.button){
          this.setState({
            button_color: nextProps.themeData.button.button_color,
            mouseover_color: nextProps.themeData.button.mouseover_color,
          });
        }
      }
      if (this.props.updateStatus !== nextProps.updateStatus) {
        if (nextProps.updateStatus) {
          this.setState({
            disabled: false,
            showAlert: false 
          });

          this.handleShow();
          this.props.renderAlert("success", nextProps.updateStatus.message);
          window.scrollTo(0, 0);
        }
      }

      if (this.props.error !== nextProps.error && !isEmpty(nextProps.error)) {
        this.setState({ showAlert: false });
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        window.scrollTo(0, 0);
      }

      if (nextProps.message) {
        this.setState({
          alertMessage: nextProps.message,
          msgType: nextProps.alertType
        });
      }
      if(this.props.contractDetails !== nextProps.contractDetails){
        if(nextProps.contractDetails){
          this.setState({contractData: nextProps.contractDetails.data, executed: nextProps.contractDetails.executed})
        }
      }
      

  }


  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({
      disabled: true,
    });
    const postData = {
      contractID : this.props.route.match.params.contractID,
      merchantExecution: [{
        name: this.state.name,
        title: this.state.title,
        email: this.state.email,
        termsAgree: this.state.termsAgree,
      }],
    }
    this.props.executeContract(postData);
  }
 

 render() {
 	let contract = this.state.contractData
        ? this.state.contractData
        : '';
    return(
      <div> 
          <form onSubmit={this.handleSubmit}>            
            <div className="container">
                
                <div className="panel margin-top">
                  <div className="panel-body" onClick={this.handleClick}>
                    {this.state.showAlert && this.state.alertMessage !=='' &&        
                      <div className="col-lg-12">
                        <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
                          <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
                        </Alert>
                      </div>
                    }
                    
                    <Row>
                    <Col md={12} xs={12}>
                    {contract ? ReactHtmlParser(contract) : ''}
                    </Col>
                    
                    {(contract !== ''  && this.state.executed == 'no') &&
                    <Col md={12} xs={12}>
                      <h4>Authorization</h4>
                    </Col>
                    }
	                </Row>
                  {(contract !== '' && this.state.executed == 'no') &&
                  <Row>
                    <Col md={4} xs={12}>
                      <ControlLabel>Please enter your full name</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.name}
                        placeholder="Enter Full Name"
                        onChange={this.handleChange}
                        required="required" 
                        name="name"
                      />
                    </Col>
                    <Col md={4} xs={12}>
                      <ControlLabel>your title</ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.title}
                        placeholder="Enter Your Title"
                        onChange={this.handleChange}
                        required="required" 
                        name="title"
                      />
                    </Col>
                    <Col md={4} xs={12}>
                      <ControlLabel>and your email address</ControlLabel>
                      <FormControl
                        type="email"
                        value={this.state.email}
                        placeholder="Enter Email Address"
                        required="required" 
                        onChange={this.handleChange}
                        name="email"
                      />
                    </Col>
                  </Row>
                  }
                  {(contract !== '' && this.state.executed == 'no') &&
                  <Row>
                    <br/>
                    <Col md={12} xs={12} className="text-center">
                      <Button bsStyle="success" style={{backgroundColor: (this.state.button_color) ? this.state.button_color : '#77C84E'}} type="submit" disabled={this.state.disabled}>BY CLICKING HERE YOU AGREE TO ALL OF THE TERMS AND CONDITIONS ABOVE<h2>EXECUTE MERCHANT AGREEMENT</h2></Button>
                    </Col>
                  </Row>
                  }
                  </div>
                </div>
            </div>
          </form>
      </div>
    );
  }
}


Proposal.propTypes = {
 getContractPoposal: PropTypes.func.isRequired,
 executeContract: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  contractDetails: state.contractReducer.contractDetail,
  updateStatus: state.pageTemplateReducer.contractStatus,
  error: state.pageTemplateReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
})



export default compose(
  connect(mapStateToProps,{getContractPoposal, renderAlert, clearAlert, executeContract})
)(Proposal);


// WEBPACK FOOTER //
// ./src/app/views/frontend/Proposal/Proposal.js